<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title"></h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.close()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <textarea ngbAutofocus rows="5" class="form-control" readonly>{{
    accountIds
  }}</textarea>
</div>
<div
  class="modal-footer d-flex justify-content-between"
  hsDraggable="modal-dialog"
>
  <button nf-button (click)="onCopy()">Copy to Clipboard</button>
</div>
